import { getApiBaseUrl } from '../config/apiBaseUrl';

async function parseResponse(response) {
  const contentType = response.headers.get('content-type');
  const data =
    contentType && contentType.includes('application/json')
      ? await response.json()
      : { error: await response.text() };

  if (!response.ok) {
    const error = new Error(data.error || `HTTP error! status: ${response.status}`);
    error.code = data.code;
    throw error;
  }

  return data;
}

export async function sendSupportMessage({ accessToken, email, topic, message }) {
  const headers = { 'Content-Type': 'application/json' };
  if (accessToken) headers.Authorization = `Bearer ${accessToken}`;

  const response = await fetch(`${getApiBaseUrl()}/api/support/contact`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ email, topic, message }),
  });

  return parseResponse(response);
}

export async function getServiceStatus(accessToken) {
  const response = await fetch(`${getApiBaseUrl()}/api/support/service-status`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return parseResponse(response);
}

export async function sendServiceRequest({ accessToken, action, reason, reasonCategory }) {
  const response = await fetch(`${getApiBaseUrl()}/api/support/service-request`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({ action, reason, reasonCategory }),
  });
  return parseResponse(response);
}
